import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'vipHome',
      component: resolve => require(['../components/vipHome/vipHome'], resolve)
    },
    {
      path: '/vipgamePrivilege',
      name: 'vipgamePrivilege',
      component: resolve => require(['../components/vipgamePrivilege/vipGamePrivilege'], resolve)
    },
    {
      path: '/vipservicePrivilege',
      name: 'vipservicePrivilege',
      component: resolve => require(['../components/vipServicePrivilege/vipServicePrivilege'], resolve)
    },
    {
      path: '/vipMember',
      name: 'vipMember',
      component: resolve => require(['../components/vipMember/vipMember'], resolve)
    },
    {
      path: '/vipNewsCenter',
      name: 'vipNewsCenter',
      component: resolve => require(['../components/vipNewsCenter/vipNewsCenter'], resolve)
    },
    {
      path: '/vipNewsDetail',
      name: 'vipNewsDetail',
      component: resolve => require(['../components/vipNewsCenter/vipNewsDetail'], resolve)
    },
    {
      path: '/vipNewsCenter/:id',
      name: 'vipnewsDetail',
      component: resolve => require(['../components/vipNewsCenter/vipNewsDetail'], resolve)
    },
    {
      path: '/personalCenter',
      name: 'personalCenter',
      component: resolve => require(['../components/vipUserCenter/vipPersonalCenter'], resolve)
    },
    {
      path: '/vipIntegralMall',
      name: 'vipIntegralMall',
      component: resolve => require(['../components/vipIntegralMall/vipIntegralMall'], resolve)
    },
    {
      path: '/vipGiftDetail',
      name: 'vipGiftDetail',
      component: resolve => require(['../components/vipIntegralMall/vipGiftDetail'], resolve)
    },
    {
      path: '/vipFaqDetail',
      name: 'vipFaqDetail',
      component: resolve => require(['../components/vipIntegralMall/vipFaqDetail'], resolve)
    },
    {
      path: '/vipFaqList',
      name: 'vipFaqList',
      component: resolve => require(['../components/vipIntegralMall/vipFaqList'], resolve)
    },
    {
      path: '/vipGrowUp',
      name: 'vipGrowUp',
      component: resolve => require(['../components/vipgamePrivilege/growUpGift'], resolve)
    },
    {
      path: '/vipBirthInfo',
      name: 'vipBirthInfo',
      component: resolve => require(['../components/vipgamePrivilege/birthInfo'], resolve)
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: resolve => require(['../components/common/protocol'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js